<form [formGroup]="fieldForm" (ngSubmit)="addField()">
    <div class="flex-column">
        <div class="flex-1">
            <h2  class="label-header" style="font-weight: bold; font-size: medium;">{{ 'EDIT-FIELD-DIALOG.FIELD-NAME' | translate }}</h2>
            <br />
            <mat-form-field style="width: 100%;" appearance="outline">
                <input [(ngModel)]="fieldName" matInput type="text" placeholder="Edit Field" formControlName="name">
                <mat-error *ngFor="let validation of field_validation_messages.name">
                    <mat-error class="error-message" *ngIf="fieldForm.get('name').hasError(validation.type) && 
                    (fieldForm.get('name').dirty || fieldForm.get('name').touched)">
                        {{validation.message}}
                    </mat-error>
                </mat-error>
            </mat-form-field>
            <br />
        </div>
        <div class="flex-1 flex-row space-around-center" style="margin-top: 10px;">
            <button mat-flat-button style="width: 40%;" (click)="cancel()" type="button" class="buttons field-cancel-btn">{{
                'ADD-FARM-DIALOG.CANCEL' |
                translate }}</button>
            <button mat-flat-button style="width: 40%;" type="submit" class="buttons field-add-btn" [disabled]="!fieldForm.valid">{{ 'EDIT-FIELD-DIALOG.UPDATE' |
                translate }}</button>
        </div>
    </div>
</form>
